import { gql } from 'apollo-boost';
import { classPackQuery } from '../constants';

export const GET_CLASS_QUERY = gql`
query studentsClass($id: ID!) {
    studentsClass(id: $id) {
        id
        name
        description
        students {
            id
            firstName
            lastName
            name
            token
            email
            loginCode
            expiredToken
            storeCode
        }
        classPacks {
           ${classPackQuery}
        }
    }
}
`;

export const GET_GROUP = gql`
    query group($groupId: ID!) {
        group(groupId: $groupId) {
            id
            name
            students {
                id
                firstName
                lastName
                name
                token
                email
                loginCode
                expiredToken
                storeCode
            }
        }
    }
`;
